module.exports = __webpack_public_path__ + "static/media/startup-smart-last@3x.3111966a.jpg";